// Permission constants for the QAP application
export const PERMISSIONS = {

  // Issues
  FILTER_ISSUES: 'FILTER_ISSUES',
  GET_ISSUE: 'GET_ISSUE',
  UPDATE_ISSUE_STATUS: 'UPDATE_ISSUE_STATUS',

  // Products
  GET_PRODUCTS: 'GET_PRODUCTS',
  ADD_PRODUCT: 'ADD_PRODUCT',
  UPDATE_PRODUCT_METADATA: 'UPDATE_PRODUCT_METADATA',
  GET_PRODUCT_BY_UUID: 'GET_PRODUCT_BY_UUID',

  // Jobs
  GET_JOBS: 'GET_JOBS',

  // Questions
  GET_QUESTIONS: 'GET_QUESTIONS',
  UPDATE_QUESTION: 'UPDATE_QUESTION',
  GET_SPECIFIC_QUESTION_DATA: 'GET_SPECIFIC_QUESTION_DATA',

  // WAS
  WAS_PREVIEW: 'WAS_PREVIEW',
  WAS_PREVIEW_ORIGINAL: 'WAS_PREVIEW_ORIGINAL',
  WAS_PREVIEW_WIP: 'WAS_PREVIEW_WIP',

  // WPDC
  SEARCH_WPDC_PRODUCTS: 'SEARCH_WPDC_PRODUCTS',
  GET_WPDC_ROOT_FOLDERS: 'GET_WPDC_ROOT_FOLDERS',

  // Editor
  EDIT_QUESTION_EQAT: 'EDIT_QUESTION_EQAT',
  GET_QUESTION_XML: 'GET_QUESTION_XML',
  SAVE_QUESTION_XML: 'SAVE_QUESTION_XML',

  // validator
  GET_VALIDATED_QUESTION_PACKAGE: 'GET_VALIDATED_QUESTION_PACKAGE',
  CHECK_PACKAGE_AVAILABILITY: 'CHECK_PACKAGE_AVAILABILITY',
  

  // SVN
  SVN_UPDATE_SF_INIT: 'SVN_UPDATE_SF_INIT',
  SAVE_QUESTION_WAS: 'SAVE_QUESTION_WAS',
  SAVE_QUESTION_SVN: 'SAVE_QUESTION_SVN',
  RELOAD_QUESTION_FROM_SVN: 'RELOAD_QUESTION_FROM_SVN',

  // User
  GET_USERS: 'GET_USERS',
  SEARCH_USERS: 'SEARCH_USERS',
  GET_USER_ACTIVITIES: 'GET_USER_ACTIVITIES',
  CREATE_USER: 'CREATE_USER',
  UPDATE_USER: 'UPDATE_USER',
  DELETE_USER: 'DELETE_USER',

  // Roles
  GET_ROLES: 'GET_ROLES',

} as const;

